<template>
  <div :class="layoutType" class="pb-5 min-vh-100">
    <HeaderPc style="min-height:auto;" />
    <!-- header begin -->
    <div class="container py-4">
      <h1 class="h3 text-mcf-color">{{ title }}</h1>
    </div>
    <!-- header end -->
    <div :class="layoutType" class="container position-sticky" style="top:0;z-index:20;">
      <!-- 分類與搜尋 begin -->
      <DeptTab class="mb-0 text-mcf-color" @changeDetailDepts="setDeptDropdownMenu">
        <div class="flex-grow-1 flex-shrink-0 d-flex justify-content-end align-items-center">
          <b-form-group class="mb-0 position-relative">
            <div class="input-icon input-icon-sm">
              <b-form-input v-model="keyword" :placeholder="$t('redeem.keyword-placeholder')" size="sm" class="font-size-md pr-5 bg-white rounded" trim lazy></b-form-input>
              <div class="input-icon-group" style="right:0;top:-2px;">
                <a :class="[keyword ? 'd-flex' : 'd-none']" href="javascript: void(0)" @click="keyword = ''">
                  <span class="material-icons text-secondary font-size-md">close</span>
                </a>
                <a class="d-flex" href="javascript: void(0)">
                  <span class="material-icons text-secondary">search</span>
                </a>
              </div>
            </div>
          </b-form-group>
        </div>
      </DeptTab>
      <!-- 分類與搜尋 end -->
      <!-- 點數bar+下拉選單 begin -->
      <div class="row justify-content-between align-items-center py-3 text-nowrap">
        <div class="col-12 col-md-12 col-lg-4 mb-3 mb-lg-0">
          <b-form-select v-if="dropdown.show" v-model="dropdown.selected" :options="dropdown.options" size="" class="bg-white"></b-form-select>
        </div>
        <div class="col-12 col-md-5 col-lg-4" v-if="hasLogged" >
          <UsablePoint class="justify-content-lg-end" />
        </div>
        <div class="col-12 col-md-5 col-lg-4" v-if="hasLogged && showCartButton">
          <CartButton class="mw-100" />
        </div>
      </div>
      <!-- 點數bar+下拉選單 end -->
    </div>
    <div class="container">
      <!-- 兌禮列表 begin -->
      <RedeemList v-show="isRedeemList"></RedeemList>
      <!-- 兌禮列表 end -->
      <router-view></router-view>
      <!-- 猜你喜歡 begin -->
      <!--
      <h5 class="text-mcf-color">猜你喜歡</h5>
      <McfProductList></McfProductList>
      -->
      <!-- 猜你喜歡 end -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CartButton from '@/components/redeem/CartButton.vue';
import DeptTab from '@/components/redeem/DeptTab.vue';
import HeaderPc from '@/components/HeaderPc.vue';
import RedeemList from '@/components/redeem/RedeemList.vue';
import UsablePoint from '@/components/redeem/UsablePoint.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';

let deptNoList = [];

export default {
  components: {
    CartButton,
    DeptTab,
    HeaderPc,
    RedeemList,
    UsablePoint,
  },
  data() {
    return {
      // 標題
      title: '',
      // 下拉選單
      dropdown: {
        // 選擇的項目
        selected: null,
        // 項目列表
        options: [],
        // 是否顯示
        show: false,
      },
      // 搜尋關鍵字
      keyword: '',
      // 顯示購物車按鈕
      showCartButton: false,
    };
  },
  computed: {
    ...mapState(['layoutType']),
    ...mapState('redeemItem', ['cartList']),
    // 是否登入
    hasLogged() {
      return !!this.$store.state.accessToken;
    },
    // 是否為兌禮列表頁
    isRedeemList() {
      const vm = this;
      return vm.$route.name === 'redeemList';
    },
  },
  watch: {
    /* eslint-disable func-names */
    'dropdown.selected': function(newValue) {
      const vm = this;
      // 選擇"請選擇選擇分類"時，取得所有子分類下兌禮商品資料
      if (!newValue) {
        vm.$store.commit('redeemItem/setItemDeptNoList', deptNoList);
        return;
      }
      // 取得對應子分類下兌禮商品資料
      vm.$store.commit('redeemItem/setItemDeptNoList', newValue);
      // 若目前不在兌禮列表，回到列表頁
      if (!vm.isRedeemList) vm.$router.push({ name: 'redeemList', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
    keyword() {
      const vm = this;
      vm.$store.commit('redeemItem/set', { name: 'keyword', value: vm.keyword });
      // 若目前不在兌禮列表，回到列表頁
      if (!vm.isRedeemList) vm.$router.push({ name: 'redeemList', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
    cartList(newValue) {
      // 購物車列表有資料就顯示購物車 (僅針對第一次進入頁面，不處理清空狀態)
      if (newValue.length) this.showCartButton = true;
    },
  },
  created() {
    const vm = this;

    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
      });
  },
  methods: {
    // 設定分類下拉選單
    setDeptDropdownMenu(depts) {
      const vm = this;

      // 若目前不在兌禮列表，回到列表頁
      if (!vm.isRedeemList) vm.$router.push({ name: 'redeemList', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });

      // 沒有子分類下拉選單不顯示，直接return
      if (!depts.length) {
        vm.dropdown.show = false;
        return;
      }

      vm.dropdown.show = true;
      // 設定選項
      vm.dropdown.options = depts.map((x) => ({
        value: [x.no],
        text: x.name,
      }));

      // 預設選擇選項
      deptNoList = depts.map((x) => (x.no));
      vm.dropdown.selected = null;
      vm.dropdown.options.unshift({
        value: null,
        text: vm.$t('redeem.dept.please-select-dept'),
      });

      // 切換主分類時，重取所有子分類下兌禮商品資料
      vm.$store.commit('redeemItem/setItemDeptNoList', deptNoList);
    },
  },
};
</script>
